<template>
  <v-card flat v-if="pedidosOffline.length > 0">
    <v-alert type="warning" outlined text class="body-1">
      <h3>Atenção</h3>
      Existem pedidos emitidos que precisam ser sincronizados
    </v-alert>
  </v-card>
</template>

<script>
import { getPedidosDB } from "@/db/pedidos";
export default {
  data: () => ({
    loading: true,
    pedidosOffline: [],
  }),
  async mounted() {
    this.loading = true;
    this.pedidosOffline = await getPedidosDB("pedidos");
    this.loading = false;
  },
};
</script>

<style>
</style>